export const overdraftDetail = {
    overdraftCollapsible: {
        showApprovedLimit: true,
        showDateSpan: true,
    },
};
